import * as React from 'react'
import { cn } from '@/lib/utils'

/*
 * TextField (design board 07): 36 high (32 in filter bars and toolbars, via
 * `h-8 text-cell`), radius 10, a 3:1 outline in border-control. Focus is a
 * primary border plus the focus halo rather than an outline ring; an error is
 * the error border, and the message below always carries an icon.
 * Read-only fields sit on the page background so they read as not editable.
 */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'border-border-control bg-surface text-foreground placeholder:text-muted-foreground file:text-foreground h-9 w-full min-w-0 rounded-md border px-3 text-sm transition-[border-color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-semibold',
        'hover:border-foreground-secondary focus-visible:border-focus-ring focus-visible:shadow-focus-halo focus-visible:outline-none',
        'aria-invalid:border-error',
        'disabled:bg-surface-muted disabled:border-border disabled:text-foreground-disabled disabled:cursor-not-allowed',
        '[&:read-only:not(:disabled)]:bg-background [&:read-only:not(:disabled)]:border-border',
        className,
      )}
      {...props}
    />
  )
}

export { Input }
